// =============================================================================
// INTAKE TYPES - Fase 1: Goal Intake & Commitment
// =============================================================================

// Re-export relevant types from main types file
export type { 
  GoalType, 
  GoalStatus, 
  GoalCommitment, 
  GoalQuestionnaireAnswers,
  Goal,
  GoalBalanceCategory,
  GoalMainCategory,
} from '../Milestone_organizer/types';

export { GOAL_BALANCE_LABELS } from '../Milestone_organizer/types';

// Intake flow step tracking
export type IntakeStep = 'category' | 'intake' | 'questionnaire' | 'confirmation' | 'missionvision' | 'commitment' | 'complete';

// Props for intake components
export interface GoalIntakeProps {
  onNext: (title: string, description?: string, startDate?: string, endDate?: string, balanceCategory?: import('../Milestone_organizer/types').GoalBalanceCategory) => void;
  initialTitle?: string;
  initialDescription?: string;
  initialStartDate?: string;
  initialEndDate?: string;
  initialBalanceCategory?: import('../Milestone_organizer/types').GoalBalanceCategory;
}

export interface GoalTypeQuestionnaireProps {
  onNext: (answers: import('../Milestone_organizer/types').GoalQuestionnaireAnswers, suggestedType: import('../Milestone_organizer/types').GoalType) => void;
  onBack: () => void;
}

export interface GoalTypeConfirmationProps {
  suggestedType: import('../Milestone_organizer/types').GoalType;
  onConfirm: (confirmedType: import('../Milestone_organizer/types').GoalType) => void;
  onBack: () => void;
}

export interface CommitmentStepProps {
  goalTitle: string;
  userId: string;
  onCommit: (commitment: import('../Milestone_organizer/types').GoalCommitment) => void;
  onBack: () => void;
}

// Goal type descriptions for UI
export const GOAL_TYPE_DESCRIPTIONS: Record<import('../Milestone_organizer/types').GoalType, { title: string; description: string }> = {
  A: {
    title: 'A-type: Bekend terrein',
    description: 'Je hebt dit doel of iets vergelijkbaars eerder behaald. Je kent de weg en weet wat er nodig is.'
  },
  B: {
    title: 'B-type: Nieuw maar zichtbaar',
    description: 'Je hebt dit doel nog niet eerder behaald, maar je hebt het wel bij anderen gezien. Je weet dat het mogelijk is.'
  },
  C: {
    title: 'C-type: Onbekend terrein',
    description: 'Dit is een groot doel dat voelt als onbekend terrein. Je weet nog niet precies hoe je het gaat bereiken.'
  }
};
